import { useEffect, useState } from "react";

// Robust on-screen-keyboard detector.
//
// The old `use-detect-keyboard-open` used only a viewport-height heuristic
// (screen.height - 300 > visualViewport.height). On phones/webviews with tall browser chrome
// that inequality is true even when NO keyboard is open, so it false-positived — which compacted
// the header and hid the Order Summary on non-input screens (e.g. the QR screen).
//
// Real "keyboard open" only matters when the user is typing, so we AND the viewport shrink with
// an actual editable-element focus check. Result: true only when an input/textarea is focused
// AND the visual viewport has shrunk — never on a screen with nothing focused.
const isEditable = (el) =>
  !!el &&
  (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);

export default function useKeyboardOpen(threshold = 140) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const vv = window.visualViewport;
    const compute = () => {
      const focused = isEditable(document.activeElement);
      const shrunk = vv ? window.innerHeight - vv.height > threshold : false;
      setOpen(focused && shrunk);
    };
    compute();
    if (vv) vv.addEventListener("resize", compute);
    window.addEventListener("focusin", compute);
    window.addEventListener("focusout", compute);
    window.addEventListener("resize", compute);
    return () => {
      if (vv) vv.removeEventListener("resize", compute);
      window.removeEventListener("focusin", compute);
      window.removeEventListener("focusout", compute);
      window.removeEventListener("resize", compute);
    };
  }, [threshold]);

  return open;
}
